import { useState } from "react";
import { Button, Card, Input, Modal } from "semantic-ui-react";
// @ts-ignore
import { CopyToClipboard } from "react-copy-to-clipboard";
import { api } from "services";
export default function CheatToken() {
  const [address, setAddress] = useState("");
  const [token, setToken] = useState(null);
  const [copy, setCopy] = useState("");
  const [showInfo, setShowInfo] = useState(false);
  async function getToken() {
    let rs = await api.post("/cheat/get-token", { wallet_address: address });
    setToken(rs);
    setShowInfo(true);
  }
  return (
    <div>
      <Modal
        open={showInfo}
        onClose={() => {
          setShowInfo(false);
        }}
      >
        <Modal.Content>
          <p>Address: {address}</p>
          <p>
            Game token:
            <CopyToClipboard
              text={token?.gameToken}
              onCopy={() => {
                setCopy("gameToken");
              }}
            >
              <span className="text-blue-700 cursor-pointer">
                {token?.gameToken}
              </span>
            </CopyToClipboard>{" "}
            {copy === "gameToken" && "Copied"}
          </p>

          <p>
            DAO token:
            <CopyToClipboard
              text={token?.daoToken}
              onCopy={() => {
                setCopy("daoToken");
              }}
            >
              <span className="text-blue-700 cursor-pointer">
                {token?.daoToken}
              </span>
            </CopyToClipboard>{" "}
            {copy === "daoToken" && "Copied"}
          </p>
        </Modal.Content>
      </Modal>
      <Card fluid>
        <Card.Content>
          <Card.Header>Get TOken</Card.Header>
        </Card.Content>
        <Card.Content>
          <p>
            Customer address/email:{" "}
            <Input
              type="text"
              onChange={(evt) => {
                setAddress(evt.target.value);
              }}
            />
          </p>
          <Button content="Get token" onClick={getToken} />
        </Card.Content>
      </Card>
    </div>
  );
}
